module.exports = __webpack_public_path__ + "static/media/logo.2da1fbcc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_components/header/logo.svg
// module id = 100
// module chunks = 0